var m = require('mithril');
var Model = require('../../libs/Model');
var formGroup = require('../../components/formGroup');
var selectInput = require('../../components/inputs/selectInput');

var trigger = Object.create(Model);

trigger.name = 'Trigger';
// trigger.url = 'trigger';
trigger['@class'] = 'Trigger';
trigger.fields = {
  id: {},
  triggerType : {
    type: 'select',
    default: 'hi',
    options: [
      {name: 'High Limit', value: 'hi'},
      {name: 'Low Limit', value: 'lo'},
      {name: 'Boolean', value: 'boolean'}
    ]
  },
  scalar: {},
  alarmReverseBoolean: {
    options: [
      {name: 'Alarm on True', value: 0},
      {name: 'Alarm on False', value: 1}      
    ]
  },
  tripDelay: {default: 0},
  resetDelay: {default : 0},
  unit: {
    default: null,
    validators: {
      unit: {}
    }
  }
};

trigger.view = function () {
  return  m('form', {role:'form'}, [
    trigger.errorView(),
    m(selectInput, {
      prop: trigger.form.triggerType,
      field: { 
        id:'triggerId', 
        options: trigger.fields.triggerType.options,
        name: 'Trigger Type:',
      }
    }, trigger.form.triggerType),
    (()=>{
      if(trigger.form.triggerType() == 'boolean'){
        return m('div',[
          m(formGroup, [
            m(selectInput, {
              prop: trigger.form.alarmReverseBoolean,
              field: { 
                id:'triggerId', 
                options: trigger.fields.alarmReverseBoolean.options,
                name: 'Alarm Behavior:',
              }
            }, trigger.form.alarmReverseBoolean),
          ])
        ])
          
      }else{
        return m('div',[
          m(formGroup, [
            m('label', {for:'trigger-scalar-input'}, 'Scalar'),
            m('input.form-control', {
              id:'trigger-scalar-input',
              type:'text',
              autocomplete: 'off',
              onchange: function (ev) {trigger.form.scalar(ev.target.value)},
              value: trigger.form.scalar(),
            })
          ]),
          m(formGroup, [
            m('label', {for:'unit-input'}, 'Unit'),
            m('input.form-control', {
              id:'unit-input',
              type:'text',
              autocomplete: 'off',
              onchange: function (ev){trigger.form.unit(ev.target.value)},
              value: trigger.form.unit(),
            })
          ])
        ])
      }
    })(),
    
    m(formGroup, [
      m('label', {for:'trigger-trip-delay-input'}, 'Trip Delay'),
      m('input.form-control', {
        id:'trigger-trip-delay-input',
        type: 'number',
        autocomplete: 'off',
        onchange: function (ev) {trigger.form.tripDelay(ev.target.value)},
        value: trigger.form.tripDelay(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'trigger-reset-delay-input'}, 'Reset Delay'),
      m('input.form-control', {
        id:'trigger-reset-delay-input',
        type: 'number',
        autocomplete: 'off',
        onchange: function (ev){trigger.form.resetDelay(ev.target.value)},
        value: trigger.form.resetDelay(),
      })
    ])
  ])
}

module.exports = trigger;
